//
//
//
//
//
//
//
//
//

export default {
  props: {
    isColor:{
      type:String,
      default:'#3BC117'
    }
  },
}



// WEBPACK FOOTER //
// ./src/common/components/g-page-loading/index.vue